import {define, singleton} from '@injex/core';
import {IConfigurations} from '../interfaces/IConfigurations';
import EntityRequestAdapter from '../utils/EntityRequestAdapter';

@define()
@singleton()
export class CloudApi extends EntityRequestAdapter<IConfigurations> {
    protected basePathName: string = 'clouds';

    protected get apiEndpoint(): string {
        return this.env.biDashboardsAPI;
    }

    public getMyCloud() {
        return this.requestWithContext({
            method: "get",
            url: `/api/clouds/me`,
        });
    }

    public updateMyCloud(configurations: IConfigurations) {
        return this.requestWithContext({
            method: "patch",
            url: `/api/clouds/me`,
            data: {configurations}
        });
    }
}
